<template>
    <transition name="fade">

        <div
            class="popup-overlay"
            :class="{ 'loading': loading, 'active': open  }"
            v-show="open"
            @mousedown="closeOverlay"
        >
            <div class="popup-main !w-max !max-h-none !h-auto" :class="{ loading : loading }">
                <div class="popup-content w-max !max-h-none !h-auto lg:rounded-5xl lg:rounded-tr-3xl !p-8 relative" :class="{ hidden: loading }">
                    <view-data-renderer :viewData="data" />
                    <div class="absolute top-1 right-4 md:block text-4xl z-20 cursor-pointer" @click="closePopup">×</div>
                    <div class="absolute top-1 right-4 md:block text-4xl z-20 cursor-pointer" @click="closePopup">×</div>
                </div>
            </div>

        </div>

    </transition>

</template>

<script>

    import ViewDataRenderer from "@/assets/js/frontend-v3/website/components/ViewDataRenderer.vue";

    export default {

        name: 'ObjectDetails',

        props: [],

        components: {
            ViewDataRenderer
        },

        data() {
            return {
                open: false,
                loading: true,

                type: null,
                reference: null,

                loadNewData: true,
                data: null,
            }
        },

        created() {

        },

        mounted() {

            window.addEventListener('keyup', (event) => {
                if (event.key === 'Escape') {
                    this.closePopup();
                }
            });

            this.Bus.on('close-object-details', () => {
                this.closePopup()
            });

            this.Bus.on('set-object-details', (data) => {

                //only load new data if requesting an object with a different reference
                this.loadNewData = this.reference !== data.reference;

                //set new data
                this.target = data.target;
                this.reference = data.reference;

                //open
                this.openPopup();
            });
        },

        methods: {

            openPopup() {

                this.open = true;
                this.setBodyStatus();

                if (this.loadNewData) {
                    this.loadData();
                }
            },

            closeOverlay(event) {
                if (event.target.classList.contains('popup-overlay')) {
                    this.closePopup()
                }
            },

            closePopup() {
                this.open = false;
                this.setBodyStatus();
            },

            setBodyStatus() {
                let body = document.body;

                if (this.open) {
                    body.classList.add('overflow-hidden');
                } else {
                    body.classList.remove('overflow-hidden');
                }
            },

            loadData() {
                this.data = '';
                this.startLoading();

                let url = '/object-details/' + this.target + '/' + this.reference;

                axios.get(url).then(response => {

                    this.data = response.data.details;

                }).catch((error) => {

                    console.log('error:');
                    console.log(error);

                    // this.$toasted.show(error.response.data.message,{
                    //     position: "top-center",
                    //     duration : 5000
                    // });
                }).then(() => {
                    this.stopLoading();
                })
            },

            startLoading() {
                this.loading = true;
            },

            stopLoading() {
                this.loading = false;
            },
        }
    }
</script>
